import axios from 'axios';

/**
 * @description 웰컴메세지
 * @param {*} userId
 * @param {*} spaceId
 * @returns
 */
const getWelcomeMsgApi = async (userId, spaceId) => {
  return await axios.post(`/api/aichat/v2/getWelcomeMsg`, { userId, spaceId });
};

/**
 * @description
 * @param {*} userId
 * @param {*} spaceId
 * @returns
 */
const startChatApi = async (userId, spaceId) => {
  return await axios.post(`/api/aichat/v2/startChat`, { userId, spaceId });
};

/**
 * @description AI와 대화하기 - AI채널
 * @param {*} userId
 * @param {*} spaceId
 * @param {*} chatId
 * @param {*} content
 * @returns
 */
const conversationApi = async (userId, spaceId, chatId, content) => {
  return await axios.post(`/api/aichat/v2/conversation`, { userId, spaceId, chatId, content });
};

/**
 * @description 예시리스트
 * @param {*} userId
 * @param {*} spaceId
 * @returns
 */
const selectExampleQuestionListApi = async (userId, spaceId) => {
  return await axios.post(`/api/aichat/v2/selectExampleQuestionList`, { userId, spaceId });
};

/**
 * @description 스페이스 채팅 웰컴조회
 * @param {*} userId
 * @param {*} spaceId
 * @returns
 */
const startChatForSpaceApi = async (userId, spaceId) => {
  return await axios.post(`/api/aichat/v2/startChatForSpace`, { userId, spaceId });
};

/**
 * @description 스페이스 등록 채팅
 * @param {*} param
 * @returns
 */
const conversationForSpaceApi = async (
  param = { userId: null, spaceId: null, chatId: null, content: null, color: null, material: null, target: null }
) => {
  return await axios.post(`/api/aichat/v2/conversationForSpace`, param);
};

/**
 * @description 채팅 종료 - 스페이스 등록
 */
const finishChatForSpaceApi = async (
  param = {
    userId: null,
    spaceId: null,
    chatId: null,
    convoNo: -1,
    recomItemNo: -1
  }
) => {
  return await axios.post(`/api/aichat/v2/finishChatForSpace`, param);
};

/**
 * @description 채팅종료 - AI채널
 * @param {*} param
 * @returns
 */
const finishChatApi = async (
  param = {
    userId: null,
    spaceId: null,
    chatId: null,
    convoNo: -1,
    recomItemNo: -1
  }
) => {
  return await axios.post(`/api/aichat/v2/finishChat`, param);
};

/**
 *
 * @param {*} userId
 * @param {*} spaceId
 * @returns
 */
const startChatForCurationApi = async (userId, spaceId) => {
  return await axios.post(`/api/aichat/v2/startChatForCuration`, {
    userId,
    spaceId
  });
};

/**
 *
 * @param {*} userId
 * @param {*} spaceId
 * @param {*} chatId
 * @param {*} content
 */
const conversationForCurationApi = async (userId, spaceId, chatId, content) => {
  return await axios.post(`/api/aichat/v2/conversationForCuration`, {
    userId,
    spaceId,
    chatId,
    content
  });
};

/**
 *
 * @param {*} userId
 * @param {*} spaceId
 * @param {*} chatId
 * @param {*} convoNo
 * @param {*} recomItemNo
 * @returns
 */
const finishChatForCurationApi = async (
  param = {
    userId: null,
    spaceId: null,
    chatId: null,
    convoNo: -1,
    recomItemNo: -1
  }
) => {
  return await axios.post(`/api/aichat/v2/finishChatForCuration`, param);
};

export {
  getWelcomeMsgApi,
  startChatApi,
  selectExampleQuestionListApi,
  startChatForSpaceApi,
  conversationForSpaceApi,
  finishChatForSpaceApi,
  finishChatApi,
  conversationApi,
  startChatForCurationApi,
  conversationForCurationApi,
  finishChatForCurationApi
};
